
<!-- This nav gives you links to click, which tells the router which route to use (defined in the routes constant in  AppRoutingModule) -->
<nav style="background-color: rgb(47, 153, 142);">
  <!-- <ul>
    <li><a routerLink="/menu-component" routerLinkActive="active">Menu</a></li>
    <li><a routerLink="/data-component" routerLinkActive="active">Data</a></li>
    <li><a routerLink="/login-component" routerLinkActive="active">Login</a></li>
  </ul> -->
  <div style="text-align: center;"><img src="assets/logoblanco.png" style="height:30px"></div>
  <!-- <div style="text-align: right;"><button class="btn-danger" (click)="logout()" >Cerrar sesión</button></div> -->
</nav>
<!-- The routed views render in the <router-outlet>-->
  <div style="background-color: #36B3A7;">
    <router-outlet></router-outlet>
  </div>

